import React, { useState } from "react";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { DialogComponent } from "../common/DialogComponent";
import RequestBreachCodesDialog from "../Dialogs/RequestBreachCodesDialog";

const RequestBreachCodes = () => {
    const [showRequestBreachCodesDialog, setShowRequestBreachCodesDialog] = useState(false);

    const openRequestBreachCodesDialog = (): any => {
        setShowRequestBreachCodesDialog(true);
    };

    const closeRequestBreachCodesDialog = (): any => {
        setShowRequestBreachCodesDialog(false);
    };

    return (
        <React.Fragment>
            <div className="box box-border-top">
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-icon position-right" aria-hidden="true">
                            <RenderIcons iconName="cube" />
                        </div>
                        <div className="box-title-text">
                            <h3 className="box-title">Request Breach Codes</h3>
                        </div>
                    </div>
                </div>
                <div className="box-content">
                    <p>If your company has experienced a data breach you can request protection for affected individuals.</p>
                    <p className="text-align-center">
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                openRequestBreachCodesDialog();
                            }}
                            type="button"
                            className="btn-default btn-primary-outline"
                        >
                            <span className="btn-text">Request Codes</span>
                        </a>
                    </p>
                </div>
            </div>
            {showRequestBreachCodesDialog && (
                <DialogComponent hideCloseButton={true} dialogId="dialog-dashboard-video" title="Add Family Member" closeDialog={closeRequestBreachCodesDialog}>
                    <RequestBreachCodesDialog closeDialog={closeRequestBreachCodesDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default RequestBreachCodes;
